import { render, staticRenderFns } from "./ContactsIndex.vue?vue&type=template&id=582b4384&scoped=true&"
import script from "./ContactsIndex.vue?vue&type=script&lang=js&"
export * from "./ContactsIndex.vue?vue&type=script&lang=js&"
import style0 from "./ContactsIndex.vue?vue&type=style&index=0&id=582b4384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582b4384",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('582b4384')) {
      api.createRecord('582b4384', component.options)
    } else {
      api.reload('582b4384', component.options)
    }
    module.hot.accept("./ContactsIndex.vue?vue&type=template&id=582b4384&scoped=true&", function () {
      api.rerender('582b4384', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/contacts/ContactsIndex.vue"
export default component.exports